import { useMutation } from 'react-query';

import { setEmailNotificationStatus as mutationFn } from 'api/endPoints/setEmailNotificationStatus';

import { ISetEmailNotificationStatusPayload } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';

export const useMutationSetEmailNotificationStatus = () => {
    return useMutation<boolean, QueryError, ISetEmailNotificationStatusPayload>((params) => mutationFn(params));
};
